
import { defineComponent } from "vue";
import {loadPaginatedMatchinPayHistory, getMatchinPayBalance}  from "@/api/matchinpay";
import MatchinPayReload from "@/components/matchinpay/MatchinPayReload.vue";
import BalanceDetails from "@/components/cards/BalanceDetails.vue";

export default defineComponent({
  name: "ecwallethistory", 
  methods: {
    async getMatchinpayBalance(){ 
      this.loading = true;
      const response = await getMatchinPayBalance();
      this.matchinpaybalance = response.data.matchinpaybalance;
      this.matchinpaybalance_currency = response.data.currency;
      this.taggedTopUpAmount = response.data.taggedTopUpAmount;

  
      this.loading = false;
      
    },
    async loadPaginatedMatchinPayHistory(){ 
      this.loading = true;
      const response = await loadPaginatedMatchinPayHistory(1);
      this.list = response.data.pageList;
      this.hasPendingMatchinPayOTP = response.data.hasPendingMatchinPayOTP;
      this.ccode = response.data.ccode;
      this.currency = response.data.currency;
      this.isAllowedMatchinPay = response.data.isShowMatchinPayReloadDiv;
      this.loading = false;
      
    },
    async refreshMatchinPayProcessModal(){ 
      this.loadPaginatedMatchinPayHistory();
    },
    onResize() {
      //this.windowHeight = window.innerHeight;
      this.windowWidth = window.innerWidth;
      if(this.windowWidth <= 450){
        this.matchinpayLogo = "https://images.empoweredconsumerism-static-files.com/ecp/MG_PAY_MOBILE.png";
        this.logoStyle = {width:"200px", height: "auto"}
      } else {
        this.matchinpayLogo = "https://images.empoweredconsumerism-static-files.com/ecp/MG_PAY_PC.png";
         this.logoStyle = {width:"500px", height: "auto"}
      }
    }
  },
  mounted(){
     
      this.loadPaginatedMatchinPayHistory();
      this.getMatchinpayBalance();
      if(localStorage.getItem("override_cifid") != null){
        this.isOverriden = true;
      }
      this.localStorageCCODE = Number(localStorage.getItem("ccode"));
      console.log(this.localStorageCCODE);
      this.onResize();
  },
  data(){
      return { 
        list : [],
        hasPendingMatchinPayOTP : "",
        loading: true,
        isOverriden : false,
        ccode : -1,
        currency : '',
        isAllowedMatchinPay : false,
        localStorageCCODE : -1,
        matchinpayLogo : "",
        windowHeight: window.innerHeight,
        windowWidth: window.innerWidth,
        logoStyle : {},
        matchinpaybalance : 0.00,
        matchinpaybalance_currency : '',
        taggedTopUpAmount : 0.00
      }
  },
  components: {
    'matchinpay-process' : MatchinPayReload,
    BalanceDetails
  },
  props: {
    widgetClasses: String
  }
});

